import styled from 'styled-components';

type Props = {
  color: string;
};

export const Wrapper = styled.div<Props>`
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ color }) => color};

  .ant-statistic-content {
    display: flex;
  }

  .ant-statistic-content-value {
    color: ${({ color }) => color} !important;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
`;
